module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("AFRO-ASIAN-AMERICAN COOKING FOR"), _c('br'), _vm._v("BIG NIGHTS, WEEKNIGHTS, & EVERY DAY")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Between"), _c('br'), _vm._v("Harlem"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _c('br'), _vm._v("Heaven")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("JJ JOHNSON AND"), _c('br'), _vm._v("ALEXANDER SMALLS")]), _vm._v(" "), _c('p', {
    staticClass: "center_t"
  }, [_c('em', [_vm._v("with Veronica Chambers")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("PHOTOGRAPHY BY")]), _vm._v(" "), _c('p', {
    staticClass: "centert1"
  }, [_vm._v("Beatriz da Costa")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("FOOD STYLING BY")]), _vm._v(" "), _c('p', {
    staticClass: "centert1"
  }, [_vm._v("Roscoe Betsill")]), _vm._v(" "), _c('p', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "OEBPS/images/3-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a4834e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 57
// module chunks = 0